import * as types from '../mutation-types'
import buyerService from '../services/buyer'

// state
export const state = {
  buyers: [],
  // Admin management state
  adminBuyers: [],
  adminBuyersTotal: 0,
  adminBuyersCurrentPage: 1,
  adminBuyersTotalPages: 0,
  adminCompanies: [],
  adminLoading: false
}

// getters
export const getters = {
  buyers: state => state.buyers,
  // Admin getters
  adminBuyers: state => state.adminBuyers,
  adminBuyersTotal: state => state.adminBuyersTotal,
  adminBuyersCurrentPage: state => state.adminBuyersCurrentPage,
  adminBuyersTotalPages: state => state.adminBuyersTotalPages,
  adminCompanies: state => state.adminCompanies,
  adminLoading: state => state.adminLoading
}

// mutation
export const mutations = {
  [types.FETCH_BUYERS_SUCCESS] (state, { buyers }) {
    state.buyers = buyers
  },
  // Admin mutations
  'SET_ADMIN_BUYERS' (state, data) {
    // Handle new PaginatedResourceCollection structure: { data: { data: [...], current_page, total, total_pages, per_page } }
    state.adminBuyers = data.data.data
    state.adminBuyersTotal = data.data.total
    state.adminBuyersCurrentPage = data.data.current_page
    state.adminBuyersTotalPages = data.data.total_pages
  },
  'SET_ADMIN_COMPANIES' (state, companies) {
    state.adminCompanies = companies
  },
  'SET_ADMIN_LOADING' (state, loading) {
    state.adminLoading = loading
  }
}

// actions
export const actions = {
  fetchBuyers ({ commit }) {
    // Legacy method - keeping for compatibility
  },
  // Admin buyer management actions
  async fetchAdminBuyers ({ commit }, params = {}) {
    commit('SET_ADMIN_LOADING', true)
    try {
      const { data } = await buyerService.fetchAdminBuyers(params)
      commit('SET_ADMIN_BUYERS', data)
      // Return the nested data structure for the component
      return data.data
    } catch (error) {
      console.error('Error fetching admin buyers:', error)
      throw error
    } finally {
      commit('SET_ADMIN_LOADING', false)
    }
  },
  async createBuyer ({ commit }, data) {
    try {
      const response = await buyerService.createBuyer(data)
      return response.data
    } catch (error) {
      console.error('Error creating buyer:', error)
      throw error
    }
  },
  async importBuyers ({ commit }, formData) {
    try {
      const { data } = await buyerService.importBuyers(formData)
      return data
    } catch (error) {
      console.error('Error importing buyers:', error)
      throw error
    }
  },
  async exportBuyers ({ commit }, exportData) {
    try {
      const { data } = await buyerService.exportBuyers(exportData)
      return data
    } catch (error) {
      console.error('Error exporting buyers:', error)
      throw error
    }
  },
  
  async downloadBuyerTemplate ({ commit }) {
    try {
      const response = await buyerService.downloadBuyerTemplate()
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Account-User-Upload-Template.xlsx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
      
      return { success: true }
    } catch (error) {
      console.error('Error downloading buyer template:', error)
      throw error
    }
  },
  async bulkDeleteBuyers ({ commit }, ids) {
    try {
      const { data } = await buyerService.bulkDeleteBuyers(ids)
      return data
    } catch (error) {
      console.error('Error bulk deleting buyers:', error)
      throw error
    }
  },
  
  async deleteBuyers ({ commit }, { ids }) {
    try {
      const { data } = await buyerService.deleteBuyers(ids)
      return data
    } catch (error) {
      console.error('Error deleting buyers:', error)
      if (error.response && error.response.data) {
        return error.response.data
      }
      throw error
    }
  },
  // Import status checking removed - handled via email notification
  
  // Column management actions
  async fetchBuyerColumns ({ commit }) {
    try {
      const { data } = await buyerService.getBuyerColumns()
      return data
    } catch (error) {
      console.error('Error fetching buyer columns:', error)
      throw error
    }
  },
  
  async updateBuyerColumn ({ commit }, columnName) {
    try {
      const { data } = await buyerService.updateBuyerColumn(columnName)
      return data
    } catch (error) {
      console.error('Error updating buyer column:', error)
      throw error
    }
  },
  
  async updateBuyerColumnOrder ({ commit }, orderedColumns) {
    try {
      const { data } = await buyerService.updateBuyerColumnOrder(orderedColumns)
      return data
    } catch (error) {
      console.error('Error updating buyer column order:', error)
      throw error
    }
  },
  
  // Update buyer's company
  async updateBuyerCompany ({ commit }, { buyerId, companyId }) {
    try {
      const { data } = await buyerService.updateBuyerCompany(buyerId, companyId)
      return data
    } catch (error) {
      console.error('Error updating buyer company:', error)
      throw error
    }
  }
}
